import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.301 2.678a3.764 3.764 0 0 0-5.29 0l-9.633 9.554a5.927 5.927 0 0 0 0 8.43 6.044 6.044 0 0 0 8.5 0l7.627-7.564a.8.8 0 0 1 1.135 0 .785.785 0 0 1 0 1.125l-7.628 7.564c-2.976 2.95-7.838 2.95-10.77 0-2.974-2.951-2.974-7.773 0-10.68l9.636-9.554a5.375 5.375 0 0 1 7.557 0 5.27 5.27 0 0 1 0 7.494l-9.223 9.147c-1.415 1.403-3.744 1.274-5.038-.274-1.026-1.368-.919-3.234.29-4.434l7.618-7.554a.8.8 0 0 1 1.134 0 .785.785 0 0 1 0 1.125L6.6 14.61c-.673.627-.688 1.622-.17 2.314.651.806 1.911.876 2.649.144L18.3 7.923a3.687 3.687 0 0 0 0-5.245"
    }, null, -1)
  ])))
}
export default { render: render }